<template lang="pug">
  .page-hero
    .page-hero__hero-image.lazyload.image--fade-in(v-if="settings.image" v-lazy:background-image="image")
    .page-hero__hero-image.page-hero__hero-image--placeholder(v-else)
      slot(name="svg")
    .page-hero__information-container.container
      .page-hero__information
        p.page-hero__pre-heading(v-if="settings.preHeading") {{ settings.preHeading }}
        h1.page-hero__title.h1(v-if="settings.heading") {{ settings.heading }}
        .page-hero__description(v-html="description")
        button.button.button--icon.button--flex.page-hero__read-more(
          v-if="settings.description.length > charLimit"
          type="button"
          @click="toggleDescription"
        )
          span {{ readMoreString }}
          icon(:name="readMoreIcon" size="12px")
      hr.page-hero__divider(v-if="divider")
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue'

  export default {
    name: 'PageHero',
    components: { Icon },
    props: {
      settings: {
        type: Object,
        default: () => ({
          image: String,
          imageMobile: String,
          preHeading: String,
          heading: String,
          description: String,
        })
      },
      divider: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        description: '',
        descriptionExpanded: false,
        charLimit: 150,
        readMoreString: 'See More',
        readMoreIcon: 'chevron-down'
      }
    },
    computed: {
      image(){
        if (this.isMobile) {
          if (!this.settings.imageMobile.includes('no-image')) {
            return this.settings.imageMobile;
          }
          if (this.settings.image !== null) {
            return this.settings.image;
          }
        }
        return this.settings.image;
      },
      isMobile() {
        return ['mobile', 'tablet'].includes(this.$mq);
      },
      trimedDescription() {
        let ellipses = this.settings.description.length > this.charLimit ? '...' : '';
        return this.settings.description.substring(0, this.charLimit) + ellipses;
      }
    },
    methods: {
      toggleDescription () {
        this.descriptionExpanded = !this.descriptionExpanded;
        this.description = this.descriptionExpanded ? this.settings.description : this.trimedDescription;
        this.readMoreIcon = this.descriptionExpanded ? 'chevron-up' : 'chevron-down';
        this.readMoreString = this.descriptionExpanded ? 'See Less' : 'See More';
      }
    },
    mounted() {
      this.description = this.trimedDescription
    },
  }
</script>

<style scoped lang="scss">
 .page-hero {  }
</style>
